export const trackAddressBookAction = (action) => {
    let event, effect
    switch (action) {
        case 'add':
            event = 'add new address'
            effect = 'open new address lightbox'
            break
        case 'edit':
            event = 'edit address'
            effect = 'open edit address lightbox'
            break
        case 'delete':
            event = effect = 'delete address'
            break
        case 'undo':
            event = 'undo address delete'
            effect = 'undo delete'
            break
    }

    return {
        event,
        effect,
        category: {
            subCategory: 'address book'
        }
    }
}
